import { Input, Label } from "@exhousing/design-system";

import { CONTACT_TEXT_FIELDS } from "@/lib/contactFields";

const SELECT = "flex h-11 w-full rounded-md border border-input bg-card px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export function ContactFieldsEditor({
  form,
  set,
}: {
  form: Record<string, string>;
  set: (key: string, value: string) => void;
}) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div className="space-y-1.5">
        <Label htmlFor="title">Salutation</Label>
        <Input
          id="title"
          placeholder="Dhr. / Mevr."
          value={form.title ?? ""}
          onChange={(e) => set("title", e.target.value)}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="gender">Gender</Label>
        <select
          id="gender"
          value={form.gender ?? ""}
          onChange={(e) => set("gender", e.target.value)}
          className={SELECT}
        >
          <option value="">—</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </div>
      {CONTACT_TEXT_FIELDS.map(({ key, label }) => (
        <div key={key} className="space-y-1.5">
          <Label htmlFor={key}>{label}</Label>
          <Input
            id={key}
            value={form[key] ?? ""}
            onChange={(e) => set(key, e.target.value)}
          />
        </div>
      ))}
      <div className="space-y-1.5">
        <Label htmlFor="language">Language</Label>
        <select
          id="language"
          value={form.language || "nl"}
          onChange={(e) => set("language", e.target.value)}
          className={SELECT}
        >
          <option value="nl">Nederlands</option>
          <option value="en">English</option>
        </select>
      </div>
    </div>
  );
}
